
import React from 'react';
import { DisplaySlide } from '../layout/DisplaySlide';
import { ContentSection } from '../layout/ContentSection';
import { SectionGrid } from '../layout/SectionGrid';
import { AdaptiveText } from '../layout/AdaptiveText';

interface PrayerTime {
  title: string;
  time: string;
  isShabbat?: boolean;
}

interface PrayerTimesSlideProps {
  times: PrayerTime[];
  title?: string;
}

export const PrayerTimesSlide: React.FC<PrayerTimesSlideProps> = ({
  times,
  title = "זמני תפילה"
}) => {
  return (
    <DisplaySlide background="gradient" padding="md">
      <div className="h-full flex flex-col space-y-6">
        {/* Slide Title */}
        <div className="text-center">
          <AdaptiveText baseSize="xl" className="font-frank font-bold text-white text-shadow-lg">
            {title}
          </AdaptiveText>
        </div>

        {/* Prayer Times Grid */}
        <SectionGrid 
          columns={times.length > 4 ? 3 : 2} 
          gap="md" 
          className="flex-1"
        >
          {times.map((prayer, index) => (
            <ContentSection
              key={index}
              title={prayer.title}
              height="fixed"
              textSize="lg"
              className={prayer.isShabbat ? "border-yellow-300/50 bg-yellow-100/10" : ""}
            >
              <div className="text-center">
                <AdaptiveText 
                  baseSize="lg" 
                  className={`font-heebo font-bold ${prayer.isShabbat ? 'text-yellow-200' : 'text-white'}`}
                >
                  {prayer.time}
                </AdaptiveText>
              </div>
            </ContentSection>
          ))}
        </SectionGrid>
      </div>
    </DisplaySlide>
  );
};
